import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { SALES_SCRIPT_SECTIONS } from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/constants'
import {
  selectCommunicationBoardState,
  selectContactConfig,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import { updateClientData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import useFormStatus from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useFormStatus'
import { isContentEmpty, withNewTabLinks } from '@/shared/tools/htmlHelper'
import { isSalesScriptAvailable } from './isSalesScriptAvailable'

type BoardSection = { section: string; content: string | null }

export type SalesScriptStatus = 'loading' | 'error' | 'empty' | 'ready'

const scriptStatus = (loaded: boolean, error: string | null, isEmpty: boolean): SalesScriptStatus => {
  if (error) return 'error'
  if (!loaded) return 'loading'
  if (isEmpty) return 'empty'
  return 'ready'
}

const useSalesScript = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const authData = useSelector(selectAuthData)
  const { formIsLoaded } = useFormStatus()
  const { selectedSalesScriptSection } = useSelector(selectContactConfig)
  const selectedSection = selectedSalesScriptSection ?? SALES_SCRIPT_SECTIONS.ENERGY
  const { sections = [], loaded = false, error = null } = useSelector(selectCommunicationBoardState)
  const hidden = !isSalesScriptAvailable(authData) || !formIsLoaded

  const content =
    (sections as BoardSection[]).find(({ section }) => section === selectedSection)?.content ?? ''

  return {
    hidden,
    title: t('subscriptionForm:sales_script_module.module_title'),
    emptyText: t('subscriptionForm:sales_script_module.empty'),
    errorText: t('subscriptionForm:sales_script_module.load_error'),
    sectionOptions: [
      { [SALES_SCRIPT_SECTIONS.ENERGY]: t('subscriptionForm:sales_script_module.energy_option') },
      { [SALES_SCRIPT_SECTIONS.TELECOM]: t('subscriptionForm:sales_script_module.telecom_option') },
    ],
    selectedSection,
    content: withNewTabLinks(content),
    status: scriptStatus(loaded, error, isContentEmpty(content)),
    selectSection: (section: string) =>
      // @ts-ignore
      dispatch(updateClientData({ data: { selectedSalesScriptSection: section }, name: 'config' })),
  }
}

export default useSalesScript
